
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"10.076","y":"5.5","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('rect',{attrs:{"x":"10.076","y":"18.5","width":"11","height":"8","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('rect',{attrs:{"x":"26.076","y":"10.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}})])
          )
        }
      }
    